<app-view-item
  *ngIf="disabled"
  [text]="displayText"
  [borderless]="borderless"
></app-view-item>

<nz-select
  *ngIf="!disabled"
  nzShowSearch
  [(ngModel)]="value"
  (ngModelChange)="onModelChange($event)"
  [nzAllowClear]="false"
  [nzDropdownMatchSelectWidth]="false"
  class="width-100"
  (keydown)="onKeydown($event)"
>
  <ng-container *ngFor="let item of options">
    <nz-option
      [nzValue]="item.value"
      [nzLabel]="item.value + ' - ' + item.label"
      nzCustomContent
    >
      <div class="dropdown-container">
        {{ item.value }} - {{ item.label }}
      </div>
    </nz-option>
  </ng-container>
</nz-select>
